export const EDIT_CROP_ACTION_TYPES = {
  START_EDITING: 'start-editing',
  STOP_EDITING: 'stop-editing',
  SET_SPECIES_TEMPLATE: 'set-species-template',
  SET_VARIETY: 'set-variety',
  SET_COUNT: 'set-count',
  SET_SUCCESSIONS: 'set-successions',
  SET_NOTES: 'set-notes',
  SEED_COUNT: 'seed-count',
  SEED_SUCCESSIONS: 'seed-successions',
  SEED_VARIETY_ID: 'seed-variety-id',
  SEED_NOTES: 'seed-notes',
  PHASE_ADJUST: 'phase-adjust',
  TASK_ADJUST: 'task-adjust',
  SUCCESSION_PHASE_ADJUST: 'succession-phase-adjust',
  SUCCESSION_TASK_ADJUST: 'succession-task-adjust',
  SET_SUBMITTING: 'set-submitting',
}

export const initialEditCropState = {
  editingCropId: null,
  variety: null,
  count: 1,
  successions: 1,
  notes: '',
  seedCount: null,        // original count when edit started (for hasEdits check)
  seedSuccessions: null,  // original succession count when edit started
  seedVarietyId: undefined, // original variety id (undefined = not yet seeded)
  seedNotes: null,        // original notes when edit started
  speciesTemplate: null,
  adjustedPhases: null,
  adjustedTasks: null,
  adjustedSuccessionData: null,  // Map<childId, {phases?, tasks?}> | null
  isSubmitting: false,
}

export function EditCropReducer(state, action) {
  switch (action.type) {
    case EDIT_CROP_ACTION_TYPES.START_EDITING:
      return { ...initialEditCropState, editingCropId: action.cropId }

    case EDIT_CROP_ACTION_TYPES.STOP_EDITING:
      return initialEditCropState

    case EDIT_CROP_ACTION_TYPES.SET_SPECIES_TEMPLATE:
      return { ...state, speciesTemplate: action.speciesTemplate }

    case EDIT_CROP_ACTION_TYPES.SET_VARIETY:
      return { ...state, variety: action.variety }

    case EDIT_CROP_ACTION_TYPES.SET_COUNT:
      return { ...state, count: action.count }

    case EDIT_CROP_ACTION_TYPES.SET_SUCCESSIONS:
      return { ...state, successions: action.successions }

    case EDIT_CROP_ACTION_TYPES.SET_NOTES:
      return { ...state, notes: action.notes }

    case EDIT_CROP_ACTION_TYPES.SEED_COUNT:
      return { ...state, count: action.count, seedCount: action.count }

    case EDIT_CROP_ACTION_TYPES.SEED_SUCCESSIONS:
      return { ...state, successions: action.successions, seedSuccessions: action.successions }

    case EDIT_CROP_ACTION_TYPES.SEED_VARIETY_ID:
      return { ...state, seedVarietyId: action.varietyId }

    case EDIT_CROP_ACTION_TYPES.SEED_NOTES:
      return { ...state, notes: action.notes, seedNotes: action.notes }

    case EDIT_CROP_ACTION_TYPES.PHASE_ADJUST:
      return { ...state, adjustedPhases: action.phases }

    case EDIT_CROP_ACTION_TYPES.TASK_ADJUST:
      return { ...state, adjustedTasks: action.tasks }

    case EDIT_CROP_ACTION_TYPES.SUCCESSION_PHASE_ADJUST: {
      const next = new Map(state.adjustedSuccessionData ?? [])
      next.set(action.childId, { ...(next.get(action.childId) ?? {}), phases: action.phases })
      return { ...state, adjustedSuccessionData: next }
    }

    case EDIT_CROP_ACTION_TYPES.SUCCESSION_TASK_ADJUST: {
      const next = new Map(state.adjustedSuccessionData ?? [])
      next.set(action.childId, { ...(next.get(action.childId) ?? {}), tasks: action.tasks })
      return { ...state, adjustedSuccessionData: next }
    }

    case EDIT_CROP_ACTION_TYPES.SET_SUBMITTING:
      return { ...state, isSubmitting: action.isSubmitting }

    default:
      throw new Error(`Unknown action sent to EditCropReducer: ${action.type}`)
  }
}
